import { Section } from '@policygenius/dif-ts-types';

const schema: Section = {
  nodeType: 'SECTION',
  urn: 'urn:pg:interview:section:continue-online-citzenship',
  content: '',
  rules: { operation: '=', field: 'children.all.valid', value: true },
  presentationRules: {
    question_insured_visa_type: {
      operation: 'OR',
      value: [
        {
          field: 'question_insured_residency_status.value',
          value: 'Visitor',
          operation: '=',
        },
        {
          field: 'question_insured_residency_status.value',
          value: 'Student visa',
          operation: '=',
        },
        {
          field: 'question_insured_residency_status.value',
          value: 'Employee visa',
          operation: '=',
        },
      ],
    },
    section_non_us_citizen: {
      operation: 'AND',
      value: [
        {
          field: 'question_insured_residency_status.value.present',
          value: true,
          operation: '=',
        },
        {
          field: 'question_insured_residency_status.value',
          value: 'Citizen',
          operation: '!=',
        },
      ],
    },
  },
  children: [
    {
      nodeType: 'QUESTION',
      questionType: 'SINGLE_CHOICE',
      urn: 'urn:pg:interview:question:insured-residency-status',
      dataPoint: {
        urn: 'urn:pg:data-point:insured-residency-status',
        dataType: 'text',
      },
      content: 'What is your residency status?',
      choices: [
        { value: 'Citizen', displayText: 'US citizen' },
        {
          value: 'Permanent resident',
          displayText: 'Permanent resident (Green Card)',
        },
        { value: 'Visitor', displayText: 'Visitor visa' },
        { value: 'Student visa', displayText: 'Student visa' },
        { value: 'Employee visa', displayText: 'Employee visa' },
      ],
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'QUESTION',
      questionType: 'SINGLE_CHOICE',
      urn: 'urn:pg:interview:question:insured-visa-type',
      dataPoint: {
        urn: 'urn:pg:data-point:insured-visa-type',
        dataType: 'text',
      },
      content: 'What is your visa type?',
      choices: [
        { displayText: 'A-1', value: 'a1' },
        { displayText: 'A-2', value: 'a2' },
        { displayText: 'A-3', value: 'a3' },
        { displayText: 'B1', value: 'b1' },
        { displayText: 'B2', value: 'b2' },
        { displayText: 'C-1', value: 'c1' },
        { displayText: 'C-1d', value: 'c1d' },
        { displayText: 'C-2', value: 'c2' },
        { displayText: 'C-3', value: 'c3' },
        { displayText: 'C-4', value: 'c4' },
        { displayText: 'C-5', value: 'c5' },
        { displayText: 'D-1', value: 'd1' },
        { displayText: 'D-2', value: 'd2' },
        { displayText: 'E-1', value: 'e1' },
        { displayText: 'E-2', value: 'e2' },
        { displayText: 'E-3', value: 'e3' },
        { displayText: 'E-4', value: 'e4' },
        { displayText: 'E-5', value: 'e5' },
        { displayText: 'F-1', value: 'f1' },
        { displayText: 'F-2', value: 'f2' },
        { displayText: 'F-3', value: 'f3' },
        { displayText: 'F-4', value: 'f4' },
        { displayText: 'G-1', value: 'g1' },
        { displayText: 'G-2', value: 'g2' },
        { displayText: 'G-3', value: 'g3' },
        { displayText: 'G-4', value: 'g4' },
        { displayText: 'G-5', value: 'g5' },
        { displayText: 'H1-B', value: 'h1b' },
        { displayText: 'H2-A', value: 'h2a' },
        { displayText: 'H2-B', value: 'h2b' },
        { displayText: 'H-3', value: 'h3' },
        { displayText: 'H-4', value: 'h4' },
        { displayText: 'I', value: 'i' },
        { displayText: 'J-1', value: 'j1' },
        { displayText: 'J-2', value: 'j2' },
        { displayText: 'K1', value: 'k1' },
        { displayText: 'L-1A', value: 'l1a' },
        { displayText: 'L-1b', value: 'l1b' },
        { displayText: 'L-2', value: 'l2' },
        { displayText: 'M-1', value: 'm1' },
        { displayText: 'M-2', value: 'm2' },
        { displayText: 'O1', value: 'o1' },
        { displayText: 'O2', value: 'o2' },
        { displayText: 'P1', value: 'p1' },
        { displayText: 'P2', value: 'p2' },
        { displayText: 'P3', value: 'p3' },
        { displayText: 'Q1', value: 'q1' },
        { displayText: 'R-1', value: 'r1' },
        { displayText: 'R-2', value: 'r2' },
        { displayText: 'SB-1', value: 'sb1' },
        { displayText: 'SD', value: 'sd' },
        { displayText: 'TN', value: 'tn' },
        { displayText: 'EAD', value: 'ead' },
        { displayText: 'Other', value: 'other' },
      ],
    },
    {
      nodeType: 'SECTION',
      content: '',
      urn: 'urn:pg:interview:section:non-us-citizen',
      rules: { operation: '=', field: 'children.all.valid', value: true },
      children: [
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-non-citizen-length-of-us-stay',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-non-citizen-length-of-us-stay',
            dataType: 'text',
          },
          content: 'How many years have you been in the United States?',
          // TODO: Convert this rule into a `match` rule that asserts the input matches any number
          rules: {
            operation: '=',
            field: 'value.present',
            value: true,
          },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'SINGLE_CHOICE',
          urn: 'urn:pg:interview:question:insured-citizenship',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-citizenship',
            dataType: 'text',
          },
          content: 'What is your country of origin?',
          choices: [
            { value: 'United States of America' },
            { value: 'Afghanistan' },
            { value: 'Albania' },
            { value: 'Algeria' },
            { value: 'American Samoa' },
            { value: 'Andorre' },
            { value: 'Angola' },
            { value: 'Anguilla' },
            { value: 'Antarctica' },
            { value: 'Antigua and Barbuda' },
            { value: 'Argentina' },
            { value: 'Armenia' },
            { value: 'Aruba' },
            { value: 'Australia' },
            { value: 'Austria' },
            { value: 'Azerbaijan' },
            { value: 'Bahamas' },
            { value: 'Bahrain' },
            { value: 'Bangladesh' },
            { value: 'Barbade' },
            { value: 'Belarus' },
            { value: 'Belgium' },
            { value: 'Belize' },
            { value: 'Benin' },
            { value: 'Bermuda' },
            { value: 'Bhutan' },
            { value: 'Bolivia' },
            { value: 'Bonaire' },
            { value: 'Bosnia and Herzegovina' },
            { value: 'Botswana' },
            { value: 'Bouvet Island' },
            { value: 'Brazil' },
            { value: 'British Indian Ocean Territory' },
            { value: 'British Virgin Islands' },
            { value: 'Brunei' },
            { value: 'Bulgaria' },
            { value: 'Burkina Faso' },
            { value: 'Burundi' },
            { value: 'Cambodia' },
            { value: 'Cameroon' },
            { value: 'Canada' },
            { value: 'Cape Verde' },
            { value: 'Cayman Islands' },
            { value: 'Central African Republic' },
            { value: 'Chad' },
            { value: 'Chile' },
            { value: 'China' },
            { value: 'Christmas Island' },
            { value: 'Cocos (Keeling) Islands' },
            { value: 'Colombia' },
            { value: 'Comoros' },
            { value: 'Congo' },
            { value: 'Congo (Dem. Rep.)' },
            { value: 'Cook Islands' },
            { value: 'Costa Rica' },
            { value: 'Crna Gora' },
            { value: 'Croatia' },
            { value: 'Cuba' },
            { value: 'Curaçao' },
            { value: 'Cyprus' },
            { value: 'Czech Republic' },
            { value: "Côte D'Ivoire" },
            { value: 'Denmark' },
            { value: 'Djibouti' },
            { value: 'Dominica' },
            { value: 'Dominican Republic' },
            { value: 'East Timor' },
            { value: 'Ecuador' },
            { value: 'Egypt' },
            { value: 'El Salvador' },
            { value: 'Equatorial Guinea' },
            { value: 'Eritrea' },
            { value: 'Estonia' },
            { value: 'Ethiopia' },
            { value: 'Falkland Islands' },
            { value: 'Faroe Islands' },
            { value: 'Fiji' },
            { value: 'Finland' },
            { value: 'France' },
            { value: 'French Guiana' },
            { value: 'French Polynesia' },
            { value: 'French Southern Territories' },
            { value: 'Gabon' },
            { value: 'Gambia' },
            { value: 'Georgia' },
            { value: 'Germany' },
            { value: 'Ghana' },
            { value: 'Gibraltar' },
            { value: 'Greece' },
            { value: 'Greenland' },
            { value: 'Grenada' },
            { value: 'Guadeloupe' },
            { value: 'Guam' },
            { value: 'Guatemala' },
            { value: 'Guernsey and Alderney' },
            { value: 'Guinea' },
            { value: 'Guinea-Bissau' },
            { value: 'Guyana' },
            { value: 'Haiti' },
            { value: 'Heard and McDonald Islands' },
            { value: 'Honduras' },
            { value: 'Hong Kong' },
            { value: 'Hungary' },
            { value: 'Iceland' },
            { value: 'India' },
            { value: 'Indonesia' },
            { value: 'Iran' },
            { value: 'Iraq' },
            { value: 'Ireland' },
            { value: 'Isle of Man' },
            { value: 'Israel' },
            { value: 'Italy' },
            { value: 'Jamaica' },
            { value: 'Japan' },
            { value: 'Jersey' },
            { value: 'Jordan' },
            { value: 'Kazakhstan' },
            { value: 'Kenya' },
            { value: 'Kiribati' },
            { value: 'Korea (North)' },
            { value: 'Korea (South)' },
            { value: 'Kuwait' },
            { value: 'Kyrgyzstan' },
            { value: 'Laos' },
            { value: 'Latvia' },
            { value: 'Lebanon' },
            { value: 'Lesotho' },
            { value: 'Liberia' },
            { value: 'Libya' },
            { value: 'Liechtenstein' },
            { value: 'Lithuania' },
            { value: 'Luxembourg' },
            { value: 'Macao' },
            { value: 'Macedonia' },
            { value: 'Madagascar' },
            { value: 'Malawi' },
            { value: 'Malaysia' },
            { value: 'Maldives' },
            { value: 'Mali' },
            { value: 'Malta' },
            { value: 'Marshall Islands' },
            { value: 'Martinique' },
            { value: 'Mauritania' },
            { value: 'Mauritius' },
            { value: 'Mayotte' },
            { value: 'Mexico' },
            { value: 'Micronesia' },
            { value: 'Moldova' },
            { value: 'Monaco' },
            { value: 'Mongolia' },
            { value: 'Montserrat' },
            { value: 'Morocco' },
            { value: 'Mozambique' },
            { value: 'Myanmar' },
            { value: 'Namibia' },
            { value: 'Nauru' },
            { value: 'Nepal' },
            { value: 'Netherlands' },
            { value: 'Netherlands Antilles' },
            { value: 'New Caledonia' },
            { value: 'New Zealand' },
            { value: 'Nicaragua' },
            { value: 'Niger' },
            { value: 'Nigeria' },
            { value: 'Niue' },
            { value: 'Norfolk Island' },
            { value: 'Northern Mariana Islands' },
            { value: 'Norway' },
            { value: 'Oman' },
            { value: 'Pakistan' },
            { value: 'Palau' },
            { value: 'Palestine' },
            { value: 'Panama' },
            { value: 'Papua New Guinea' },
            { value: 'Paraguay' },
            { value: 'Peru' },
            { value: 'Philippines' },
            { value: 'Pitcairn' },
            { value: 'Poland' },
            { value: 'Portugal' },
            { value: 'Puerto Rico' },
            { value: 'Qatar' },
            { value: 'Romania' },
            { value: 'Russia' },
            { value: 'Rwanda' },
            { value: 'Réunion' },
            { value: 'Saint Barthélemy' },
            { value: 'Saint Helena' },
            { value: 'Saint Kitts and Nevis' },
            { value: 'Saint Lucia' },
            { value: 'Saint Martin' },
            { value: 'Saint Pierre and Miquelon' },
            { value: 'Saint Vincent and the Grenadines' },
            { value: 'Samoa' },
            { value: 'San Marino' },
            { value: 'Saudi Arabia' },
            { value: 'Senegal' },
            { value: 'Serbia' },
            { value: 'Seychelles' },
            { value: 'Sierra Leone' },
            { value: 'Singapore' },
            { value: 'Sint Eustatius and Saba' },
            { value: 'Sint Maarten' },
            { value: 'Slovakia' },
            { value: 'Slovenia' },
            { value: 'Solomon Islands' },
            { value: 'Somalia' },
            { value: 'South Africa' },
            { value: 'South Georgia and the South Sandwich Islands' },
            { value: 'South Sudan' },
            { value: 'Spain' },
            { value: 'Sri Lanka' },
            { value: 'Sudan' },
            { value: 'Suriname' },
            { value: 'Svalbard and Jan Mayen' },
            { value: 'Swaziland' },
            { value: 'Sweden' },
            { value: 'Switzerland' },
            { value: 'Syria' },
            { value: 'São Tomé and Príncipe' },
            { value: 'Taiwan' },
            { value: 'Tajikistan' },
            { value: 'Tanzania' },
            { value: 'Thailand' },
            { value: 'Togo' },
            { value: 'Tokelau' },
            { value: 'Tonga' },
            { value: 'Trinidad and Tobago' },
            { value: 'Tunisia' },
            { value: 'Turkey' },
            { value: 'Turkmenistan' },
            { value: 'Turks and Caicos Islands' },
            { value: 'Tuvalu' },
            { value: 'Uganda' },
            { value: 'Ukraine' },
            { value: 'United Arab Emirates' },
            { value: 'United Kingdom' },
            { value: 'United States Minor Outlying Islands' },
            { value: 'Uruguay' },
            { value: 'Uzbekistan' },
            { value: 'Vanuatu' },
            { value: 'Vatican City' },
            { value: 'Venezuela' },
            { value: 'Vietnam' },
            { value: 'Virgin Islands of the United States' },
            { value: 'Wallis and Futuna' },
            { value: 'Western Sahara' },
            { value: 'Yemen' },
            { value: 'Zambia' },
            { value: 'Zimbabwe' },
            { value: 'Åland Islands' },
          ],
          rules: { field: 'value.present', value: true, operation: '=' },
        },
      ],
    },
  ],
};

export default schema;
